import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconMicrophone } from "@tabler/icons-react"
import BaseListItem from "../base"

const InterviewListItem = ({ item, className, footer }: any) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconMicrophone}
    typeLabel="Interview"
    testId="interview-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.READ }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="w-[300px] max-w-full rounded-xl"
          />
        </a>
      )
    }
  />
)

export default InterviewListItem
